/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlRemoveYourListsRequest
 */
export interface ControlRemoveYourListsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlRemoveYourListsRequest
     */
    form_ids: Array<string>;
}

/**
 * Check if a given object implements the ControlRemoveYourListsRequest interface.
 */
export function instanceOfControlRemoveYourListsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "form_ids" in value;

    return isInstance;
}

export function ControlRemoveYourListsRequestFromJSON(json: any): ControlRemoveYourListsRequest {
    return ControlRemoveYourListsRequestFromJSONTyped(json, false);
}

export function ControlRemoveYourListsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlRemoveYourListsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_ids': json['form_ids'],
    };
}

export function ControlRemoveYourListsRequestToJSON(value?: ControlRemoveYourListsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_ids': value.form_ids,
    };
}

